import React from "react";

import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

import { Button, Col, Dropdown, Row, Space } from "antd";

import { SlOptions } from "react-icons/sl";
import { FaRegCopy } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";

import {
  addendumTemplates,
  attachments,
  LeasTemplates,
} from "../../../../data/leases";

import "./LeaseTemplates.css";
import SubHeading from "../../../../components/common/SubHeading";
import { useState } from "react";
import ConfirmationBox from "../../../../components/common/ConfirmationBox";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import EditEelectronicSignature from "../../../../components/common/EditElectronicSignature";

function LeaseTemplates() {
  const [leaseTemplates, setLeaseTemplates] = useState(LeasTemplates);
  const [
    leaseTemplatesConfirmationBoxOpen,
    setLeaseTemplatesConfirmationBoxOpen,
  ] = useState(false);
  const [leaseTemplateId, setLeaseTemplateId] = useState(0);
  const [leaseTemplateName, setLeaseTemplateName] = useState("");

  const [addendumTemplatesData, setAddendumTemplatesData] =
    useState(addendumTemplates);
  const [
    addendumTemplatesConfirmationBoxOpen,
    setAddendumTemplatesConfirmationBoxOpen,
  ] = useState(false);
  const [addendumTemplateId, setAddendumTemplateId] = useState(0);
  const [addendumTemplateName, setAddendumTemplateName] = useState("");

  const [attachmentsData, setAttachmentsData] = useState(attachments);
  const [attachmentsConfirmationBoxOpen, setAttachmentsConfirmationBoxOpen] =
    useState(false);
  const [attachmentId, setAttachmentId] = useState(0);
  const [attachmentName, setAttachmentName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [
    newAttachmentConfirmationBoxOpen,
    setNewAttachmentConfirmationBoxOpen,
  ] = useState("");

  const handleNewLeaseTemplate = () => {
    window.open("/new_lease_template", "_Blank");
  };
  const handleNewbbendum = () => {
    window.open("/new_addendum", "_Blank");
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const onCancelModal = () => {
    setIsModalOpen(false);
  };

  const LeaseTemplatesRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        <span onClick={handleNewLeaseTemplate}>New Lease Template</span>,
        "1",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <span onClick={handleNewbbendum}>New Addendum</span>,
        "2",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <span onClick={() => setNewAttachmentConfirmationBoxOpen(true)}>
          New Attachment
        </span>,
        "3",
        "",
        "",
        ""
      ),
      RightBarMethod(
        "Manage Manually Entered Fields",
        "4",
        "",
        "",
        "/leasing/leases/lease-templates/manage-manually-entered-fields"
      ),
      RightBarMethod("PDF Form Templates", "5", "", "", ""),
      RightBarMethod(
        <span onClick={showModal}>Edit Electronic Signature</span>,
        "6",
        "",
        "",
        ""
      ),
    ]),
  ];

  const setData = (item) => {
    setLeaseTemplateId(item.id);
    setLeaseTemplateName(item.title);
  };

  function handleMenuClick({ key }) {
    console.log(key);
    if (Number(key) === 2) {
      setLeaseTemplatesConfirmationBoxOpen(true);
    }
  }

  const deleteLeaseTemplate = (id) => {
    const newArray = leaseTemplates.filter((item) => {
      return item.id !== id;
    });

    setLeaseTemplates(newArray);
    setLeaseTemplatesConfirmationBoxOpen(false);
  };

  const setAddendumData = (item) => {
    setAddendumTemplateId(item.id);
    setAddendumTemplateName(item.title);
  };

  function handleAddendumMenuClick({ key }) {
    console.log(key);
    if (Number(key) === 2) {
      setAddendumTemplatesConfirmationBoxOpen(true);
    }
  }

  const deleteAddendumTemplate = (id) => {
    const newArray = addendumTemplatesData.filter((item) => {
      return item.id !== id;
    });

    setAddendumTemplatesData(newArray);
    setAddendumTemplatesConfirmationBoxOpen(false);
  };

  const setAttachmentData = (item) => {
    setAttachmentId(item.id);
    setAttachmentName(item.title);
    setAttachmentsConfirmationBoxOpen(true);
  };

  const items = [
    {
      key: "1",
      icon: <FaRegCopy />,
      label: "Copy",
    },
    {
      key: "2",
      icon: <RiDeleteBin6Line />,
      label: "Delete",
    },
  ];

  const deleteAttachment = (id) => {
    const newArray = attachmentsData.filter((item) => {
      return item.id !== id;
    });
    setAttachmentsData(newArray);
    setAttachmentsConfirmationBoxOpen(false);
  };
  return (
    <>
      <div className="lease-templates">
        <PageHeading heading="Lease Templates" />
        <div className="lease-templates-container">
          <div className="templates">
            <Row className="header-row">
              <Col span={22} className="data-col">
                <span>Name</span>
              </Col>
              <Col span={2} className="data-col">
                <span>Action</span>
              </Col>
            </Row>
            {leaseTemplates.map((item, index) => {
              return (
                <Row className="data-row" key={index}>
                  <Col span={22} className="data-col onclick-text">
                    <span>{item.title}</span>
                  </Col>
                  <Col span={2} className="data-col">
                    <Dropdown
                      menu={{
                        items,
                        onClick: handleMenuClick,
                      }}
                      onClick={() => setData(item)}
                      trigger={["click"]}
                    >
                      <a
                        href="nothing"
                        onClick={(e) => e.preventDefault()}
                        style={{ textDecoration: "none" }}
                      >
                        <Space className="options">
                          Options
                          <SlOptions />
                        </Space>
                      </a>
                    </Dropdown>
                  </Col>
                </Row>
              );
            })}
          </div>
          <div className="addendum-templates">
            <SubHeading subHeading="Addendum Templates" />
            <div className="addendum-templates-container">
              <Row className="header-row">
                <Col span={22} className="data-col">
                  <span>Name</span>
                </Col>
                <Col span={2} className="data-col">
                  <span>Action</span>
                </Col>
              </Row>
              {addendumTemplatesData.map((item, index) => {
                return (
                  <Row className="data-row" key={index}>
                    <Col span={22} className="data-col onclick-text">
                      <span>{item.title}</span>
                    </Col>
                    <Col span={2} className="data-col">
                      <Dropdown
                        menu={{
                          items,
                          onClick: handleAddendumMenuClick,
                        }}
                        onClick={() => setAddendumData(item)}
                        trigger={["click"]}
                      >
                        <a
                          href="nothing"
                          onClick={(e) => e.preventDefault()}
                          style={{ textDecoration: "none" }}
                        >
                          <Space className="options">
                            Options
                            <SlOptions />
                          </Space>
                        </a>
                      </Dropdown>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </div>
          <div className="attachments">
            <SubHeading subHeading="Attachments" />
            <div className="attachments-container">
              <Row className="header-row">
                <Col span={22} className="data-col">
                  <span>Name</span>
                </Col>
                <Col span={2} className="data-col">
                  <span>Action</span>
                </Col>
              </Row>
              {attachmentsData.map((item, index) => {
                return (
                  <Row className="data-row" key={index}>
                    <Col span={22} className="data-col onclick-text">
                      <span>{item.title}</span>
                    </Col>
                    <Col span={2} className="data-col">
                      <span
                        className="delete-btn"
                        onClick={() => setAttachmentData(item)}
                      >
                        Delete
                      </span>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={LeaseTemplatesRightBar} />
      </div>
      {leaseTemplatesConfirmationBoxOpen ? (
        <ConfirmationBox
          setIsConfirmationBoxOpen={setLeaseTemplatesConfirmationBoxOpen}
        >
          <h2>Please Confirm</h2>
          <p className="message">
            Are you sure you want to delete {leaseTemplateName}?
          </p>
          <div className="action-buttons">
            <button
              className="red"
              onClick={() => deleteLeaseTemplate(leaseTemplateId)}
            >
              Deleted
            </button>
            <button
              className="cancel-btn"
              onClick={() => setLeaseTemplatesConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
      {addendumTemplatesConfirmationBoxOpen ? (
        <ConfirmationBox
          setIsConfirmationBoxOpen={setAddendumTemplatesConfirmationBoxOpen}
        >
          <h2>Please Confirm</h2>
          <p className="message">
            Are you sure you want to delete {addendumTemplateName}?
          </p>
          <div className="action-buttons">
            <button
              className="red"
              onClick={() => deleteAddendumTemplate(addendumTemplateId)}
            >
              Deleted
            </button>
            <button
              className="cancel-btn"
              onClick={() => setAddendumTemplatesConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
      {attachmentsConfirmationBoxOpen ? (
        <ConfirmationBox
          setIsConfirmationBoxOpen={setAttachmentsConfirmationBoxOpen}
        >
          <h2>Please Confirm</h2>
          <p className="message">
            Are you sure you want to delete {attachmentName}?
          </p>
          <div className="action-buttons">
            <button
              className="red"
              onClick={() => deleteAttachment(attachmentId)}
            >
              Deleted
            </button>
            <button
              className="cancel-btn"
              onClick={() => setAttachmentsConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
      {newAttachmentConfirmationBoxOpen ? (
        <ConfirmationBox
          setIsConfirmationBoxOpen={setNewAttachmentConfirmationBoxOpen}
        >
          <h2>New Attachment</h2>
          <p className="message">
            Select a file to upload. You will be able to attach the uploaded
            document to your templates.
          </p>
          {/* <AttachmentsUpload /> */}
          <div className="action-buttons">
            <Button
              type="primary"
              onClick={() => setNewAttachmentConfirmationBoxOpen(false)}
            >
              Upload
            </Button>
            <button
              className="cancel-btn"
              onClick={() => setNewAttachmentConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
      <EditEelectronicSignature
        showModal={isModalOpen}
        cancelModal={onCancelModal}
      />
    </>
  );
}

export default LeaseTemplates;
